import { render, staticRenderFns } from "./timeRight.vue?vue&type=template&id=d87494ba&scoped=true&"
import script from "./timeRight.vue?vue&type=script&lang=js&"
export * from "./timeRight.vue?vue&type=script&lang=js&"
import style0 from "./timeRight.vue?vue&type=style&index=0&id=d87494ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87494ba",
  null
  
)

export default component.exports